import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';

import Topbar from './topbar';
import Sidebar from './sidebar';
import Routes from './routes';

const Home = () => {
    const [openSideMenu, setOpenSideMenu] = useState(false);

    const handleSideMenuOpen = () => {
        setOpenSideMenu(true);
    };

    const handleSideMenuClose = () => {
        setOpenSideMenu(false);
    };

    return (
        <>
            <Topbar handleSideMenuOpen={handleSideMenuOpen} />
            <Sidebar openSideMenu={openSideMenu} handleSideMenuClose={handleSideMenuClose} />
            <Grid container id="main">
                <Routes />
            </Grid>
        </>
    )
}

export default Home;